import { FolkInstrument, FolkToolbar } from '../folk-toolbar';
FolkInstrument.define();
FolkToolbar.define();
export { FolkInstrument, FolkToolbar };
//# sourceMappingURL=folk-toolbar.js.map